import { render, staticRenderFns } from "./SvgSprite.vue?vue&type=template&id=4626d530"
import script from "./SvgSprite.vue?vue&type=script&lang=js"
export * from "./SvgSprite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports